export class UserIndicator {
    id: string;
    uid: string;
    indicator: string;
    integration: string;
    active: boolean;
    target: string;
}